import { FOOTER, SHOW_FOOTER, SHOW_FOOTER_UI, } from "@frameworks/web/redux/interfaces/IFooter";
class FooterActions {
    getMarketStatus(FooterEntityList) {
        return {
            type: FOOTER,
            payload: {
                data: FooterEntityList,
            },
        };
    }
    updateShowMob_Menu(showFooter) {
        return {
            type: SHOW_FOOTER,
            payload: { showFooter },
        };
    }
    setShowFooterUi(showFooterUi) {
        return {
            type: SHOW_FOOTER_UI,
            payload: { showFooterUi },
        };
    }
}
export default FooterActions;
